import { Area, Box, Text, useTheme } from '@ublend-npm/aulaui-core';
import React, { ReactNode } from 'react';

interface NoResultsCardProps {
  title?: string;
  description?: string;
  sx?: Record<string, unknown>;
  titleSx?: Record<string, unknown>;
  descriptionSx?: Record<string, unknown>;
  icon?: ReactNode;
  iconSx?: Record<string, unknown>;
}

const NoResultsCard = ({
  title,
  description,
  sx: sxProp,
  titleSx: titleSxProp,
  descriptionSx: descriptionSxProp,
  icon: iconProp,
  iconSx: iconSxProp,
}: NoResultsCardProps) => {
  const theme = useTheme() as any;

  const defaultSx = {
    borderRadius: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '0.5rem',
  };

  const defaultTitleSx = {};
  const defaultDescriptionSx = { color: theme.palette.text.secondary };

  return (
    <Area
      role="status"
      aria-label={title || 'No results found'}
      aria-live="polite"
      sx={{
        ...defaultSx,
        ...sxProp,
      }}
    >
      {iconProp != null && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            lineHeight: 0,
            ...iconSxProp,
          }}
        >
          {iconProp}
        </Box>
      )}
      <Text
        kind="p1"
        fontWeight={titleSxProp ? undefined : '550'}
        sx={titleSxProp ? { ...defaultTitleSx, ...titleSxProp } : undefined}
      >
        {title || 'No results found'}
      </Text>
      <Text
        kind="p2"
        sx={{
          ...defaultDescriptionSx,
          ...descriptionSxProp,
        }}
      >
        {description || ''}
      </Text>
    </Area>
  );
};

export default NoResultsCard;
